import { Col, DatePickerField, ErrorMessage } from '@/components';
import { DEFAULT_ANALYSIS_START_YEAR } from '@/features/analysis/_utils';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import dayjs from 'dayjs';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { KsAnalysisSearchFormType } from '../../_models/ks-analysis-search';

export const KsFiscalYearColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<KsAnalysisSearchFormType>();

  return (
    <Col span={8} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <DatePickerField
        name="fiscalYear"
        label={t('created-fiscal-year')}
        control={control}
        errors={errors}
        picker="year"
        shouldCoexistOnChange
        disabledDate={(value) => {
          return value.isBefore(
            dayjs().year(DEFAULT_ANALYSIS_START_YEAR),
            'year',
          );
        }}
        required
        allowClear={false}
        wrapperStyle={{ marginBottom: 0 }}
        hiddenErrorMessage
      />
      <ErrorMessage errors={errors} name="fiscalYear" />
    </Col>
  );
});
